export default 
  [
    { code2: "en", name: "English" },
    { code2: "pt", name: "Portuguese" },
    { code2: "ar", name: "Arabic" },
    // { code2: "es", name: "Spanish" },
    // { code2: "fr", name: "French" },
  ];